export const HYBIRD_PLP_TRACKING = 'hybridPLP';
export const CARD_HEIGHT = 140;
export const MAX_CARD_HEIGHT = 190;
export const OFFER_AVAILABLE_MESSAGE = 'Offer Available';
export const HYBRID_LP_LOAD = 'hybrid_lp_loads';
export const HYBRID_PDP_EXP = 'hybrid_pdp_exp';
export const HYBRID_LP = 'hybridLP';
export const HLP_PAGE_TYPE = 'hybridLandingPage';
export const ADD_TO_BAG = 'Add To Bag';
export const GO_TO_BAG = 'Go To Bag';
export const HLP_OFFER_COUPONS_LOADS = 'offer_coupon_loads';
export const COLLECT_COUPONS = 'Collect Coupons';
export const AVAILABLE = 'AVAILABLE';
export const HOW_TO_COLLECT_COUPONS = 'How to collect coupons ';
export const COLLECT_OFFERS = 'View Offers';
